import NotLoggedInLayout from "./not-logged-in.layout";

export default NotLoggedInLayout;
